import _News from '@/components/newsPage/News';
import useAmplitude from '@/hooks/useAmplitude';

export const News = () => {
  useAmplitude('news');
  return <_News />;
};

export default News;
